import { BookX } from "lucide-react";

const ErrorTemplate = () => {
  return (
    <div className="min-h-screen bg-vintageBg flex items-center justify-center font-montserrat p-8">
      <section className="flex items-center h-full">
        <div className="container flex flex-col items-center justify-center px-5 mx-auto">
          <BookX
            className="w-24 h-24 md:w-28 md:h-28 text-vintageText text-opacity-80 mb-6"
            strokeWidth={1.5}
          />

          <p className="text-2xl md:text-3xl text-vintageText mb-4 text-center">
            Chapter Not Found
          </p>

          <p className="text-lg text-vintageText text-opacity-80 mb-8 max-w-md text-center">
            It seems this page has been misplaced in our library archives. The
            story you're looking for isn't on this shelf.
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="/"
              className="px-8 py-3 bg-vintageText text-light rounded-md hover:bg-vintageText hover:bg-opacity-90 transition-colors font-semibold text-center"
            >
              Return to Library
            </a>
            <a
              href="/category"
              className="px-8 py-3 border-2 border-vintageText border-opacity-30 text-vintageText rounded-md hover:bg-vintageText hover:bg-opacity-10 transition-colors font-semibold text-center"
            >
              Browse Collection
            </a>
          </div>

          <div className="mt-12 p-6 border-2 border-vintageText border-opacity-20 rounded-lg bg-vintageText bg-opacity-5">
            <p className="text-vintageText text-opacity-80 italic text-center">
              "Not all those who wander are lost, but sometimes pages are."
            </p>
            <p className="text-vintageText text-opacity-60 text-sm text-center mt-2">
              - Ancient Librarian Proverb
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ErrorTemplate;
